module.exports = __webpack_public_path__ + "img/견적서.2d7aae22.jpg";